export default __webpack_public_path__ + "static/media/Excelra.2fdb401d.png";